import ArticleIcon from "@mui/icons-material/Article";
import { PUBLICATIONS, PublicationServicePath } from "utils/constants";
import ListEmployeePublications from "./List";
import ShowEmployeePublication from "./Show/Show";

export const resources = {
  isMenu: true,
  icon: <ArticleIcon />,
  name: PublicationServicePath + PUBLICATIONS,
  title: "Публикации",
  recordRepresentation: "title",
  list: <ListEmployeePublications />,
  show: <ShowEmployeePublication />,
};
